import { render, staticRenderFns } from "./expandTask.modal.vue?vue&type=template&id=5c55c8be&scoped=true"
import script from "./expandTask.modal.vue?vue&type=script&lang=js"
export * from "./expandTask.modal.vue?vue&type=script&lang=js"
import style0 from "./expandTask.modal.vue?vue&type=style&index=0&id=5c55c8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55c8be",
  null
  
)

export default component.exports